export interface ClearlineApiConfig {
  apiUrl: string;
}
